import { SortSymbols } from '@webitel/ui-sdk/src/scripts/sortQueryAdapters';

export default [
  {
    value: 'name',
    locale: 'objects.name',
    field: 'name',
    sort: SortSymbols.NONE,
  },
  {
    value: 'source',
    locale: 'objects.integrations.importCsv.source',
    field: 'source',
    sort: SortSymbols.NONE,
  },
];
